import { Formik, FormikHelpers } from "formik";
import { FC } from "react";
import { useDispatch } from "react-redux";
import { addOrEditIndustryValidation } from "../../helper/constant";
import usePathName from "../../hooks/usePathName";
import { onAddIndustry } from "../../service/industry";
import AddOrEditIndustry from "./AddOrEditIndustry";
import { useNavigate } from "react-router-dom";
import { IndustryInterface } from "../../helper/interface";
import { ArrowLeftCircle } from "react-feather";

const AddIndustry: FC = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    usePathName([
        { pathName: "Industry", href: "/position" },
        { pathName: "Add", href: "/industry/add " },
    ]);

    const onSubmitIndustry = (values: IndustryInterface, { resetForm }: FormikHelpers<IndustryInterface>) => {
        onAddIndustry(values, dispatch, navigate, resetForm);
    };

    return (
        <div className="intro-y box py-10 sm:py-10 mt-5">
            <div className="flex w-full items-center">
                <div className="flex-2 ml-4">
                    <ArrowLeftCircle className="cursor-pointer text-primary" onClick={() => navigate("/position")} />
                </div>
                <div className="flex-1 font-medium text-center text-lg -ml-2">Add new industry</div>
            </div>
            <div className="px-5 sm:px-20 mt-10 pt-10 border-t border-slate-200/60 dark:border-darkmode-400">
                <Formik
                    initialValues={{
                        name: "",
                        positions: [],
                    }}
                    validationSchema={addOrEditIndustryValidation}
                    onSubmit={onSubmitIndustry}
                >
                    {(props) => <AddOrEditIndustry {...props} />}
                </Formik>
            </div>
        </div>
    );
};

export default AddIndustry;
